import { AdvancedSearchEntityType } from "generated/graphql";

export const getEntityIconName = (entityKind: string): string => {
    switch (entityKind) {
        case AdvancedSearchEntityType.Client:
            return "07_ClientInfo";
        case AdvancedSearchEntityType.Community:
            return "57_Community";
        case AdvancedSearchEntityType.ReferenceContact:
            return "40_ReferralPerson";
        case AdvancedSearchEntityType.ReferenceBusiness:
            return "39_Business";
        case AdvancedSearchEntityType.HomeCareLead:
            return "07_ClientInfo";
        default:
            return "07_ClientInfo";
    }
};
